import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuid } from 'uuid';

import { isResource, LibraryResource, NewResource, Resource, ResourceState } from './types';
import { indexResource } from '.';
import { authActions } from '../auth/slice';
import { uiActions } from '../ui/slice';
import { saveResource } from './actions';


const resourceSlice = createSlice({
  name: 'resources',
  initialState: {} as ResourceState,
  reducers: {
    bulkImport: (state, action) => {
      Object.assign(state, action.payload);
      delete state['_loaded'];
    },
    bulkDelete: (state, action: PayloadAction<string[]>) => {
      for (const resourceID of action.payload) {
        delete state[resourceID];
      }
    },
    deleteResource: (state, action: PayloadAction<Resource>) => {
      if (isResource(action.payload)) {
        delete state[action.payload.id];
      }
      else {
        delete state[action.payload];
      }
    },
    rebuildIndex: (state) => {
      for (const resource of Object.values(state)) {
        indexResource(resource);
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(authActions.logOut, () => ({}))
          .addCase(uiActions.setCurrentLiveResource, (state, action) => {
            const resourceID = action.payload?.resource?.id;
            if (resourceID && state[resourceID]) {
              state[resourceID].meta.lastUsed = Date.now();
            }
          })
          .addCase(
            saveResource,
            (state, action: PayloadAction<NewResource>) => {
              const resource = {
                ...action.payload,
                meta: { ...action.payload.meta }
              } as LibraryResource;

              if (!resource.id) {
                resource.id = uuid();
              }
              resource.meta.modified = Date.now();
              if (!state[resource.id]) {
                resource.meta.created = resource.meta.modified;
              }
              state[resource.id] = resource;
              indexResource(resource);
            }
          );
  }
});

export const resourceActions = resourceSlice.actions;

export default resourceSlice.reducer;
